import { getUserId, tafRequest } from 'amkit3-modules/utils/taf'
import { HUYA as ServerCommon } from '../../../../common/jce/ServerCommon'
import { Taf } from '@huyafed/taf-network'
import { getCookie, getCookieVal } from 'amkit3-modules/utils/utils'

/**
 * 根据视频ID批量获取动态信息
 * @param lVid - 视频ID，数字类型
 * @returns 返回一个Promise，解析为获取到的动态信息响应
 */
export const GetMomentBatchByVid = async (lVid: (number | string)[] = []) => {
  let req = new ServerCommon.GetMomentBatchByVidReq()
  const vVideoId = new Taf.Vector(new Taf.INT64())
  vVideoId.value = lVid
  req.tId = getUserId() as any
  req.vVideoId = vVideoId
  req.iOutterDataCond = 2
  return tafRequest({
    moduleName: 'moment',
    funcName: 'getMomentBatchByVid',
    data: req,
    reqClass: ServerCommon.GetMomentBatchByVidReq,
    rspClass: ServerCommon.GetMomentBatchByVidRsp,
  })
}
